module.exports = __webpack_public_path__ + "static/media/tournaments-active-menu-icon.6f9b5eac.svg";